module.exports = __webpack_public_path__ + "Images/nodata.svg";


//////////////////
// WEBPACK FOOTER
// ./Images/nodata.svg
// module id = 302
// module chunks = 2